<script>
    import { onMount } from 'svelte';
    import { getData, resultEvaluationDone, getAnswerHighlights } from '../utility.js';
    import Button from '../ui_elements/Button.svelte';
    import { push } from 'svelte-spa-router';
    import ContentBox from '../layouts/ContentBox.svelte';
    import Popup from '../ui_elements/Popup.svelte';
    import ResultDetails from './results-components/ResultDetails.svelte';
    import ResultTable from './results-components/ResultTable.svelte';
    import PageBox from "../layouts/PageBox.svelte";
    import { exportGutachtenAsWord, getJobTypeScoreStrings } from './results-components/results-utility';
    import ScoreChart from "./results-components/ScoreChart.svelte";
    import Spinner from "../misc/Spinner.svelte";
    
    let message = "";
    
    let resultsReady;
    resultEvaluationDone.subscribe(value => { resultsReady = value });

    const topRow = {columnName: "Fähigkeit", leftLabel: "kann ich nicht so gut", rightLabel: "kann ich sehr gut"}; // for the scorechart in the teilnahmebescheinigung (certificate)
    let answerHighlights = ""; // saves the answer highlights, also used for the certificate

    let rows = []
    let resultsStudium;
    let resultsAusbildung;
    let jobTypeScore = 0;

    let isPopupOpen = false;
    let selectedResult = null;

    onMount(async () => {
        const data = await getData('get-results/');
        resultsStudium = data.results_studium;
        resultsAusbildung = data.results_ausbildung;
        jobTypeScore = data.job_type_score;
        rows = [{label1: "Studium", score: jobTypeScore, label2: "Ausbildung"}]
        console.log(data);

        const hash = window.location.hash;
        if (hash.indexOf('?') !== -1){ 
            const urlParams = new URLSearchParams(hash.split('?')[1]);
            message = urlParams.get('m') || '';
        }

        if (message === 'feedback') {
            message = "Vielen Dank für dein Feedback! Wir werden es für die weitere Entwicklung des Fragebogens berücksichtigen. Du kannst dein Feedback jederzeit anpassen, gehe dafür einfach über den Button wieder auf die Feedbackseite.";
        }

        answerHighlights =  await getAnswerHighlights();
          
    });

    function openPopup(event) {
        isPopupOpen = true;
        selectedResult = event.detail;
    }
    
</script>

<PageBox pageTitle="Deine Ergebnisse">       
    {#if message !== ""}
        <div class="mb-4 p-4 bg-accent2-background border border-accent2-border text-accent2-text rounded w-2/3">
            {message}
        </div>            
    {/if}

    {#if !resultsReady}
        <ContentBox>
            <div>Dein Fragebogen wird ausgewertet. Die Auswertung dauert etwa eine Minute, danach kannst du deine Ergebnisse sehen!</div>
            <Spinner/>
        </ContentBox>
    {:else if resultsStudium}  
        <ContentBox>
            <h1 class="font-semibold">{getJobTypeScoreStrings(jobTypeScore)[0]}</h1>
            {getJobTypeScoreStrings(jobTypeScore)[1]}
            <ScoreChart {rows} />
        </ContentBox>

        <!-- display order depends on score  -->
        {#if jobTypeScore < 0.5} 
            {#if resultsStudium.length > 0}
                <ContentBox>
                    <h1 class="font-semibold">Studiengänge</h1>
                    <p  class="mb-2">Auf Basis deiner Interessen, Fähigkeiten und weiterer Angaben werden dir die folgenden Studiengänge empfohlen. Du kannst auf die einzelnen Ergebnisse klicken, um mehr Informationen zu dem Studiengang zu erfahren.</p>
                    <ResultTable results={resultsStudium} resultType="Studiengang" on:openPopup={openPopup} />
                </ContentBox>
            {/if}

            {#if resultsAusbildung.length > 0}
                <ContentBox>
                    <h1 class="font-semibold">Ausbildungen</h1>
                    <p class="mb-2">Auf Basis deiner Interessen, Fähigkeiten und weiterer Angaben werden dir die folgenden Ausbildungen empfohlen. Du kannst auf die einzelnen Ergebnisse klicken, um mehr Informationen zu der Ausbildung zu erfahren.</p>
                    <ResultTable results={resultsAusbildung} resultType="Ausbildung" on:openPopup={openPopup} />
                </ContentBox>
            {/if}
        {:else}
            {#if resultsAusbildung.length > 0}
                <ContentBox>
                    <h1 class="font-semibold">Ausbildungen</h1>
                    <p class="mb-2">Auf Basis deiner Interessen, Fähigkeiten und weiterer Angaben werden dir die folgenden Ausbildungen empfohlen. Du kannst auf die einzelnen Ergebnisse klicken, um mehr Informationen zu der Ausbildung zu erfahren.</p>
                    <ResultTable results={resultsAusbildung} resultType="Ausbildung" on:openPopup={openPopup} />
                </ContentBox>
            {/if}

            {#if resultsStudium.length > 0}
                <ContentBox>
                    <h1 class="font-semibold">Studiengänge</h1>
                    <p  class="mb-2">Auf Basis deiner Interessen, Fähigkeiten und weiterer Angaben werden dir die folgenden Studiengänge empfohlen. Du kannst auf die einzelnen Ergebnisse klicken, um mehr Informationen zu dem Studiengang zu erfahren.</p>
                    <ResultTable results={resultsStudium} resultType="Studiengang" on:openPopup={openPopup} />
                </ContentBox>
            {/if}
        {/if}

        <ContentBox>
            <h1 class="font-semibold">Teilnahmezertifikat und Gutachten</h1>
            <p  class="mb-2">Hier kannst du dein Teilnahmezertifikat und ein für dich erstelltes Gutachten herunterladen.</p>

            <p class="mb-2">Dein <b>Teilnahmezertifikat</b> bestätigt, dass du den Fragebogen erfolgreich bearbeitet hast. Zusätzlich enthält es dein Stärkenprofil auf der zweiten Seite.</p>

            <p class="mb-2">Dein <b>Gutachten</b> beinhaltet eine Zusammenfassung deiner Antworten im Fragebogen sowie die Liste der empfohlenen Studiengänge und Ausbildungen. Für jedes Ergebnis gibt es eine detaillierte Beschreibung. Für deinen weiteren Weg gibt es im Gutachten Entscheidungshilfen zur Wahl zwischen den Ergebnissen. Auch für die Wahl einer Hochschule oder eines Ausbildungsplatzes gibt es Entscheidungshilfen.</p>

            <div class="flex mx-4 mb-2 justify-between w-full">
                {#if answerHighlights}
                    <div class="mb-2">
                        <ScoreChart display="none" rows={answerHighlights['faehigkeiten_subcategory_scores']} {topRow} bescheinigung=true fullName={answerHighlights.name.name == '' ? answerHighlights.name.username : answerHighlights.name.name} />
                    </div>
                {/if}

                <Button on:click={exportGutachtenAsWord} variant="submit">Gutachten als Word-Datei speichern</Button>
            </div>
    

        </ContentBox>


        <ContentBox>
            Du hast Feedback zum Fragebogen, zur Website oder zu deinen Ergebnissen? Wir freuen uns sehr über deine Anmerkungen! Hier kannst du ein paar kurze Feedbackfragen beantworten: 
            <div class="flex justify-end w-full">
                <Button on:click={() => push('/feedback')} variant="submit">Zum Feedbackbogen</Button>
            </div>
        </ContentBox>

        <div class="flex mx-4 mb-2 justify-left w-2/3" style="min-width: 600px">
            <Button on:click={() => push('/answers')}>Zurück zur Antwortübersicht</Button>
        </div>
        
    {/if}

    <Popup bind:isOpen={isPopupOpen} width="w-2/3" style="min-width: 600px">
        <ResultDetails result={selectedResult}/>
    </Popup>
</PageBox>
